module.exports = __webpack_public_path__ + "static/media/information-outline.cc8ded03.svg";